import { COLORS } from 'src/styles/theme'
import styled from 'styled-components'

export const Page = styled.div`
  font-size: 0.8em;
  /* height: 100%; */
  /* backdrop-filter: blur(10px); */
  /* background-color: rgba(255,255,255,0.5); */
  /* padding: 32px 24px; */
  height: 70%;

  .card-container {
    height: 100%;
    margin: 16px 0;
    position: relative;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(17.25px);
    border-radius: 8px;

    .messages {
      height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;
      border-radius: 8px;
    }
  }
  .helptext {
    text-align: center;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    padding: 8px;
  }
  form#chat-form {
    width: 100%;
    background: transparent;
    text-align: right;

    .form-input {
      display: block;
      width: 100%;
      background: #fff;
      resize: none;
      outline: none;
      border: 3px solid ${COLORS.primary};
      padding: 8px 12px;
      font-size: 12px;
      border-radius: 8px;
      font-weight: 500;
      &::placeholder {
        font-style: italic;
      }
    }
    .btn {
      font-size: 14px;
      font-weight: 600;
      color: ${COLORS.primary};
      background: transparent;
      padding-right: 0;
      cursor: pointer;

      svg {
        margin: 0 4px;
      }
    }
  }
`
